import Chart from 'react-apexcharts';
import type { Props as ChartProps } from 'react-apexcharts';
import { useColorModeValue } from '@chakra-ui/react';

interface BarChartProps {
  chartData: ChartProps['series'];
  chartOptions?: ApexCharts.ApexOptions;
}

export default function BarChart({ chartData, chartOptions }: BarChartProps) {
  const textColor = useColorModeValue('#1B2559', '#FFFFFF');
  const gridColor = useColorModeValue('#E0E5F2', '#2D3748');

  const defaultOptions: ApexCharts.ApexOptions = {
    chart: {
      toolbar: { show: false },
    },
    tooltip: { theme: 'dark' },
    dataLabels: { enabled: false },
    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: '40px',
      },
    },
    colors: ['#6200ea', '#39B8FF'],
    xaxis: {
      labels: { style: { colors: textColor, fontSize: '12px', fontWeight: '500' } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: { style: { colors: textColor, fontSize: '12px', fontWeight: '500' } },
    },
    legend: { show: false },
    grid: {
      show: true,
      borderColor: gridColor,
      strokeDashArray: 5,
      yaxis: { lines: { show: true } },
      xaxis: { lines: { show: false } },
    },
  };

  const mergedOptions = { ...defaultOptions, ...chartOptions };

  return (
    <Chart
      options={mergedOptions}
      series={chartData}
      type="bar"
      width="100%"
      height="100%"
    />
  );
}
